"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var Save = function Save() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M357.5,71.2c-42.9,0-83.2,33.8-102.6,53c-19.4-19.1-59.6-53-102.6-53c-73.4,0-117.4,43-117.4,114.9c0,58.9,54,108.3,56,110 l153.2,147.8c2.9,2.9,6.9,4.4,10.8,4.4s7.9-1.5,10.8-4.4l153-147.3c2.2-2.2,56.3-51.5,56.2-110.5C474.9,114.2,430.9,71.2,357.5,71.2 z M389.3,264.9c-0.2,0.2-134.4,129.4-134.4,129.4L120.9,265c-0.5-0.5-1-0.9-1.5-1.4c-10.8-9.9-41.3-44.9-41.3-77.5 c0-23.7,6.1-41.7,18.2-53.5c15.3-15,38.9-18.2,56-18.2c19.5,0,46.5,15.2,72.3,40.6c0.6,0.6,14.4,14,19,18.6c6.1,6,16.8,6.1,22.8,0 c5.4-5.5,18.3-18.1,18.9-18.7c25.6-25.4,52.6-40.5,72.2-40.5c17.1,0,40.7,3.2,56,18.2c12.1,11.8,18.2,29.8,18.2,53.5 C431.7,214.4,408.9,246.2,389.3,264.9z"
  }));
};

Save.displayName = 'Save';
var _default = Save;
exports["default"] = _default;
Save.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Save"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Save.js"] = {
    name: "Save",
    docgenInfo: Save.__docgenInfo,
    path: "src/Save.js"
  };
}